define((require) => {
    "use strict";

    const ImprovedView = require("editor/zbone/ImprovedView");

    /**
     * Abstract properties view to handle shared functionality.
     *
     * @class PropertiesView
     * @constructor
     *
     * @cfg {WidgetModel} model The model for the widget being edited.
     */
    return ImprovedView.extend({
        expandProperty: null,

        _$accordionControl: null,
        _$accordionTarget: null,

        _shouldExpandOnRender() {
            if ("shouldExpandOnRender" in this.options) {
                return this.options.shouldExpandOnRender;
            }
            return this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty];
        },

        _accordionControlsExist() {
            return this._$accordionControl && this._$accordionControl.length > 0;
        },

        onRender() {
            this.__super();
            this._$accordionControl = this.$el.find(".collapsible[data-target]");

            if (this._accordionControlsExist()) {
                this._$accordionTarget = this.$el.find(this._$accordionControl.data("target"));
            }
        },

        onShow() {
            if (!this._accordionControlsExist()) {
                return;
            }
            this._$accordionTarget.on("show.bs.collapse", () => {
                this._$accordionControl.toggleClass("collapsed", false);
            });

            this._$accordionTarget.on("hide.bs.collapse", () => {
                this._$accordionControl.toggleClass("collapsed", true);
            });

            if (this._shouldExpandOnRender()) {
                this._$accordionTarget.collapse("show");
            }
        },

        onBeforeClose() {
            if (this._accordionControlsExist()) {
                this._$accordionTarget.off("show.bs.collapse hide.bs.collapse shown.bs.collapse hidden.bs.collapse");

                if (this.expandProperty) {
                    this.viewScope.viewModel.get("widgetPropertyViewsState")[this.expandProperty] = this._$accordionTarget.hasClass("in");
                }
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/AbstractWidgetPropertiesView.js